import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchSources = params => api.request(1, '/dataSourceTypes', MethodType.GET, params)

export const fetchDataSource = params => api.request(1, '/dataSources', MethodType.GET, params)

export const fetchDataSourceByBrand = (brand, type, params) => api.request(1, `/dataSourcesByBrand/${brand}/${type}`, MethodType.GET, params)

export const delDataSource = (id, params) => api.request(1, `/dataSources/${id}`, MethodType.DELETE, params)

export const delGA4DataSource = (id, params) => api.request(1, `/ga4/dataSourceDelete/${id}`, MethodType.DELETE, params)

export const addDataSource = params => api.request(1, '/dataSourceAndSchemas', MethodType.POST, params)

export const addGA4DataSource = params => api.request(1, '/ga4/dataSourceCreate', MethodType.POST, params, { 'Content-Type': 'multipart/form-data' })

export const modDataSource = (id, params) => api.request(1, `/dataSourceAndSchemas/${id}`, MethodType.PUT, params)

export const addUploadDataSrc = (id, params) => api.request(1, `/dataSourceCreate/${id}`, MethodType.POST, params, { 'Content-Type': 'multipart/form-data' })

export const modUploadDataSrc = (id, params) => api.request(1, `/dataSourceUpdate/${id}`, MethodType.POST, params, { 'Content-Type': 'multipart/form-data' })

// ----- DATA SOURCE BRAND ----- //
export const addBrandDataSource = params => api.request(1, '/brandDataSourceBulkCreate', MethodType.POST, params)

export const modBrandDataSource = params => api.request(1, '/brandDataSourceBulkModify', MethodType.PATCH, params)

// ----- DATA SOURCE SCHEMA ----- //
export const fetchDefaultSchema = (id, params) => api.request(1, `/defaultDataSourceSchemas/${id}`, MethodType.GET, params)

export const fetchSchema = (id, params) => api.request(1, `/dataSourceSchemasByDataSource/${id}`, MethodType.GET, params)

// ----- TYPE OPTIONS ----- //
export const fetchFirstPartyType = params => api.request(1, '/firstPartyDataTypes', MethodType.GET, params)

export const fetchLineType = params => api.request(1, '/lineTypes', MethodType.GET, params)

export const fetchSiteType = params => api.request(1, '/groupSites', MethodType.GET, params)

export const fetchTrackType = params => api.request(1, '/groupTrackBrands', MethodType.GET, params)

// ----- MAPPING KEYS ----- //
export const fetchMappingKeys = params => api.request(1, '/mappingKeys', MethodType.GET, params)

export const delMappingKeys = (id, params) => api.request(1, `/mappingKeys/${id}`, MethodType.DELETE, params)

export const checkMappingKeys = (id, params) => api.request(1, `/checkMappingKeyUsed/${id}`, MethodType.GET, params)

export const addMappingKeys = (params) => api.request(1, '/mappingKeys', MethodType.POST, params)

export const modMappingKeys = (id, params) => api.request(1, `/mappingKeys/${id}`, MethodType.PUT, params)

export const fetchPiiAndMappingKeys = (brandId, params) => api.request(1, `/getPiiAndMappingKey/${brandId}`, MethodType.GET, params)

export const fetchPii = (brandId, params) => api.request(1, `/getPii/${brandId}`, MethodType.GET, params)

// ----- MAPPING KEYS ----- //
export const fetchCryptDataSourceId = (id, params) => api.request(1, `/getCryptDataSourceId/${id}`, MethodType.GET, params)
